import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Observable, of} from 'rxjs';
import {AuthService} from './service/auth.service';
import {catchError, map} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslocoService} from '@ngneat/transloco';
import {LocalizeRouterService} from "@penleychan/ngx-transloco-router";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private transloco: TranslocoService,
    private snackBar: MatSnackBar,
    private localizeRouter: LocalizeRouterService,
    private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.authService.isAuthenticated().pipe(map((response: boolean) => {
      if (response) {
        if (next.data.roles && next.data.roles.length) {
          if (!this.authService.hasAccess(next.data.roles)) {
            this.router.navigate([this.localizeRouter.translateRoute('/login')]);
            return false;
          }
        }
        return true;
      }
      this.router.navigate([this.localizeRouter.translateRoute('/login')]);
      return false;
    }), catchError((error) => {
      this.router.navigate([this.localizeRouter.translateRoute('/login')]);
      return of(false);
    }));
  }
}
